import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";
import {
  AddOwnerIpWhitelistRequest,
  CreateOwnerData,
  CreateOwnerRequest,
  DeleteOwnerIpWhitelistRequest,
  OwnerApiKeysListData,
  OwnerIpWhitelistListData,
  OwnersApiResponse,
  OwnersListData,
  RevokeOwnerApiKeyRequest,
  ToggleOwnerIpWhitelistRequest,
  UpdateOwnerContactRequest,
} from "../models/Owners/OwnersModels";

class OwnersApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiClient();
  }

  public async listOwners(): Promise<OwnersApiResponse<OwnersListData>> {
    const response = await this.api.get<OwnersApiResponse<OwnersListData>>(
      "/adminPanel/whitelabel/owners",
    );
    return response.data;
  }

  public async createOwner(
    data: CreateOwnerRequest,
  ): Promise<OwnersApiResponse<CreateOwnerData>> {
    const response = await this.api.post<OwnersApiResponse<CreateOwnerData>>(
      "/adminPanel/whitelabel/owners",
      data,
    );
    return response.data;
  }

  public async updateOwnerContact(
    data: UpdateOwnerContactRequest,
  ): Promise<OwnersApiResponse> {
    const response = await this.api.post<OwnersApiResponse>(
      "/adminPanel/whitelabel/owners/contact",
      data,
    );
    return response.data;
  }

  public async listOwnerApiKeys(
    ownerId: number,
  ): Promise<OwnersApiResponse<OwnerApiKeysListData>> {
    const response = await this.api.get<OwnersApiResponse<OwnerApiKeysListData>>(
      "/adminPanel/whitelabel/apiKeys",
      { params: { ownerId } },
    );
    return response.data;
  }

  public async revokeOwnerApiKey(
    data: RevokeOwnerApiKeyRequest,
  ): Promise<OwnersApiResponse> {
    const response = await this.api.post<OwnersApiResponse>(
      "/adminPanel/whitelabel/apiKeys/revoke",
      data,
    );
    return response.data;
  }

  public async listOwnerIpWhitelist(
    ownerId: number,
  ): Promise<OwnersApiResponse<OwnerIpWhitelistListData>> {
    const response = await this.api.get<
      OwnersApiResponse<OwnerIpWhitelistListData>
    >("/adminPanel/whitelabel/ipWhitelist", { params: { ownerId } });
    return response.data;
  }

  public async addOwnerIpWhitelistEntry(
    data: AddOwnerIpWhitelistRequest,
  ): Promise<OwnersApiResponse> {
    const response = await this.api.post<OwnersApiResponse>(
      "/adminPanel/whitelabel/ipWhitelist",
      data,
    );
    return response.data;
  }

  public async toggleOwnerIpWhitelistEntry(
    data: ToggleOwnerIpWhitelistRequest,
  ): Promise<OwnersApiResponse> {
    const response = await this.api.post<OwnersApiResponse>(
      "/adminPanel/whitelabel/ipWhitelist/toggle",
      data,
    );
    return response.data;
  }

  public async deleteOwnerIpWhitelistEntry(
    data: DeleteOwnerIpWhitelistRequest,
  ): Promise<OwnersApiResponse> {
    const response = await this.api.post<OwnersApiResponse>(
      "/adminPanel/whitelabel/ipWhitelist/delete",
      data,
    );
    return response.data;
  }
}

export const ownersApiService = new OwnersApiService();
